window.selectize_all_selects = function () {
    $('select:visible:not(.no-selectize)').not('.selectized').each(function (i, select) {
        $select = $(select);
        $select.selectize({
            onChange: function (value) {
                var link_to = $select.data("dashboard-link");
                if (link_to !== undefined && value !== '') {
                    window.location.href = link_to + "/" + value
                } else if ($select.data("autosubmit")) {
                    $select.get(0).form.submit();
                }
            }
        });
    });
}

$(function() {
    var url = document.location.toString();
    if (url.match('#')) {
        $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
    }

    // Change hash for page-reload
    $('.nav-tabs a').on('shown.bs.tab', function (e) {
        var target = e.target.hash;
        window.location.hash = target;
    });
});

$(function() {
    var $frame = $('.slider__container');
    var $wrap  = $frame.parent();

    // Call Sly on frame
    var panel_slyder = $frame.sly({
        horizontal: 1,
        itemNav: 'forceCentered',
        smart: 1,
        activateMiddle: 1,
        activatePageOn: 'click',
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        startAt: 0,
        scrollBy: 1,
        speed: 300,
        elasticBounds: 1,
        dragHandle: 1,
        dynamicHandle: 1,
        clickBar: 1,

        pagesBar: $wrap.find('.slider__pager'),
    });

    $(window).smartresize(function(){
        if (panel_slyder != null) {
            panel_slyder.sly('reload');
        }
    });

    var enabledTabs = [
        '#shareholder-tab-1 a',
        '#shareholder-tab-2 a',
        '#shareholder-tab-3 a',
        '#pool-tab-1 a',
        '#pool-tab-2 a',
    ];

    $.each(enabledTabs, function(index, element) {
        $(element).click(function (e) {
            $(this).tab('show');
            $.scrollTo($(element), {
                offset: -($(element).height())
            })
            e.preventDefault();
        });
    });

    // register sliding content handler
    $('.gridder').gridderExpander({
        scroll: true,
        scrollOffset: 30,
        scrollTo: "listitem",                  // panel or listitem
        animationSpeed: 400,
        animationEasing: "swing",
        showNav: true,                      // Show Navigation
        nextText: "",                   // Next button text
        prevText: "",               // Previous button text
        closeText: "",                 // Close button text
        onContent: function(){
            //Gridder Content Loaded
            selectize_all_selects();
            ContactFormHelper.registerContactFormHandler();
            $('input, textarea').placeholder();
        }
    });
    $('.carousel').carousel();
    selectize_all_selects();

    var superSearch = document.getElementById( 'sb-search' );
    if (superSearch != null) {
        new UISearch( superSearch );
    }

    // this should be in controller specific JS

    $('form.auto-submit').find('select').on('change', function(event, data) {
        $(this).closest('form').submit();
    });

    ExpandContent.expandContentHandler();
    $('body').vacancy();
});
